import { yupResolver } from "@hookform/resolvers/yup";
import React, { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { getLocalStorage, removeLocalStorage } from "../../utils";
import { apiConstants } from "../../utils/constants/apiConstants";
import { getURLstylistCode } from "../../utils/globalFunctions";
import { getSignInRedirect } from "../../utils/signInRedirect";
import {
  noValidation,
  phoneValidation,
  signupValidation,
} from "../onboarding/ValidationSchema";
import Otp from "./Otp";
import SignUp from "./SignUp";
import SignUpForm from "./SignUpForm";

export default function SignIn() {
  const navigate = useNavigate();

  const [stepNo, setStepNo] = useState(1);

  const validationSchema = useMemo(() => {
    if (stepNo === 1) {
      return phoneValidation;
    }
    if (stepNo === 2) {
      return noValidation;
    }
    if (stepNo === 3) {
      return signupValidation;
    }
    return noValidation;
  }, [stepNo]);

  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
    getValues,
    setValue,
    watch,
    trigger,
  } = useForm({
    defaultValues: {
      [apiConstants.mobile_number]: "",
      [apiConstants.country_code]: "",
      [apiConstants.first_name]: "",
      [apiConstants.last_name]: "",
      [apiConstants.email]: "",
      [apiConstants.terms_check]: false,
      [apiConstants.email_reminders_opt_in]: false,
    },
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });

  const is_not_registered = getLocalStorage("is_registered_online_consumer1");
  const is_registered = getLocalStorage("is_registered_online_consumer");
  const goAfterAuth = () => {
    const dest = getSignInRedirect(
      window.location.search,
      getURLstylistCode()
    );
    if (dest.kind === "back") {
      navigate(-1);
      return;
    }
    navigate(dest.path);
  };
  const handleNext = () => {
    handleSubmit((_data) => {
      if (stepNo === 2 && is_registered) {
        removeLocalStorage("is_registered");
        goAfterAuth();
      } else {
        setStepNo(stepNo + 1);
      }

      if (stepNo === 3 && is_not_registered) {
        removeLocalStorage("is_not_registered");
        goAfterAuth();
      } else if (stepNo === 3) {
        goAfterAuth();
      } else {
        setStepNo(stepNo + 1);
      }
    })();
  };
  const handlePrevious = () => {
    setStepNo(stepNo - 1);
  };

  return (
    <div>
      <div className="booking-wrapper">
        {stepNo === 1 && (
          <SignUp
            control={control}
            watch={watch}
            errors={errors}
            handleNext={handleNext}
            isValid={isValid}
            setValue={setValue}
            getValues={getValues}
          />
        )}

        {stepNo === 2 && (
          <Otp
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            getValues={getValues}
            setValue={setValue}
            setStepNo={setStepNo}
          />
        )}

        {stepNo === 3 && (
          <SignUpForm
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            getValues={getValues}
            setValue={setValue}
            control={control}
            watch={watch}
            errors={errors}
            isValid={isValid}
            trigger={trigger}
          />
        )}
      </div>
    </div>
  );
}
